import { Release } from "@packages/commons";

export const REDUX_PROP = "fullRelease";
export type State = {
  value: null | Release;
}
const defaultState: State = { value: null };

/** The loaded full release, or null when there's no release in scope or the one loaded isn't it. */
export const selectFullRelease = (s: any): Release | null => {
  const { release } = s[ "scope" ];
  const fullReleaseState: State = s[ REDUX_PROP ];
  // if we don't have a release in scope, or its not the one loaded, return null
  if (!release || release !== fullReleaseState.value?.id) return null;
  return fullReleaseState.value;
};

export const aTypes = {
  requestToActualize: "fullRelease/requestToActualize",
  set: "fullRelease/set",
}as const;

export type Actions = {
  requestToActualize: {
    type: typeof aTypes.requestToActualize;
  };
  set: {
    type: typeof aTypes.set;
    payload: State[ "value" ];
  }
}
export type AllActions = Actions[ keyof Actions ];

export const aCreators: {
  [ K in keyof Actions ]: Actions[ K ] extends { payload: unknown }
    ? (p: Actions[ K ][ "payload" ]) => Actions[K]
    : () => Actions[K]
} = {
  requestToActualize: () => ({ type: aTypes.requestToActualize }),
  set: p => ({ type: aTypes.set, payload: p })
};

export function reducer(s = defaultState, a: AllActions): typeof s {
  switch (a.type) {
    case aTypes.set: return { value: a.payload };
    default: return s;
  }
}
